import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { actions, SectionNames, selectors } from 'builder/modules/resumeEditor'
import {
  SectionBodyFoldableContainer,
  SectionHeader,
  SectionHeaderFoldableContainer,
  SectionHint,
} from 'builder/components/Section'
import { SectionContainer, SectionContent } from 'builder/components/Section/styles'
import SectionTitle from 'builder/components/SectionTitle'
import { useI18n } from 'builder/hooks/useI18n'
import RichTextArea from 'builder/components/RichTextArea/RichTextArea'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'

export const CustomSection = () => {
  const { i18n } = useI18n()
  const spaceForPersonalRequests = useTypedSelector(
    state => state.resumeEditor.resume?.spaceForPersonalRequests,
  )
  const { updateSimpleField } = actions
  const dispatch = useDispatch()
  const isOpened = useTypedSelector(store => selectors.isSectionOpened(store, SectionNames.custom))

  const onChangeCallback = useCallback(
    (value: string) => {
      dispatch(updateSimpleField({ name: 'spaceForPersonalRequests', value }))
    },
    [dispatch, updateSimpleField],
  )

  const handleToggle = useCallback(() => {
    dispatch(actions.setOpenedSections({ [SectionNames.custom]: !isOpened }))
  }, [dispatch, isOpened])

  return (
    <>
      <SectionContainer>
        <SectionHeader isOpened={isOpened} onClick={handleToggle}>
          <SectionTitle
            title={i18n.t('builder.resume_editor.custom_section.title')}
            isOpened={isOpened}
          />
          <SectionHeaderFoldableContainer isOpened={isOpened}>
            <SectionHint>{i18n.t('builder.resume_editor.custom_section.hint')}</SectionHint>
          </SectionHeaderFoldableContainer>
        </SectionHeader>

        <SectionBodyFoldableContainer isOpened={isOpened}>
          <SectionContent>
            {/* TODO: Add label to i18n if AB test succeeds */}
            <RichTextArea
              value={spaceForPersonalRequests || ''}
              onChange={onChangeCallback}
              // disableToolbar to disable the toolbar
              disableToolbar
            />
          </SectionContent>
        </SectionBodyFoldableContainer>
      </SectionContainer>
    </>
  )
}
